import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActionAlert } from '../../../../core/dto/actionAlert';
import { FleetService } from '../../../../core/services/fleet.service';
import { DriverService } from '../../../../core/services/driver.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { OtherReservationService } from '../../../../core/services/other-reservation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IDeactivateComponent } from '../../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';
import { differenceInCalendarDays } from 'date-fns';
import { SupplierService } from '../../../../core/services/supplier.service';
import { CurrencyService } from '../../../../core/services/currency.service';
import { SETTINGS } from '../../../../core/config/common.settings';
import { AppUtils } from '../../../../core/config/app.utils';

@Component({
  selector: 'app-add-edit-other-reservation',
  templateUrl: './add-edit-other-reservation.component.html',
  styleUrls: ['./add-edit-other-reservation.component.scss'],
})
export class AddEditOtherReservationComponent
  implements OnInit, IDeactivateComponent
{
  breadcrumbs: any[] = [];
  otherBookingId: any;
  otherBookingForm: FormGroup | any;
  formErrors: any;
  actionMessage = new ActionAlert();
  vehicleCat: any;
  availableVehicles = [{ _id: '', vehicleName: '', availabilityStatus: '' }];
  filteredAvailableVehicles = [
    { _id: '', vehicleName: '', availabilityStatus: '' },
  ];
  availableDriver: any;
  filteredAvailableDriver: any;
  visibleAddDriverPopup = false;
  visibleAddVehiclePopup = false;
  outSourced = [{ _id: '', refNo: '' }];
  supplierVehicleOptions: any[] = [];
  filteredSupplierVehicleOptions: any[] = [];
  reservationId: any;
  prevPage: any;
  vehicle = {
    image: 'assets/img/image-placeholder.png',
    registrationNo: '-',
    mileage: 0,
    fuel: 0,
    seats: 0,
  };
  driver = {
    name: '-',
    mobileNo: '-',
    supplier: '-',
  };
  bookingData: any;
  subbmit = false;
  loading = false;
  currencyOptions: any[] = [];
  supplierId = '';
  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;
  availabilityStatusPairs = SETTINGS.AVAILABILITY_STATUS_PAIRS;
  driverAvailabilityStatus = SETTINGS.DRIVER_AVAILABILITY_STATUS;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  constructor(
    private message: NzMessageService,
    private fb: FormBuilder,
    private fleetService: FleetService,
    private driverService: DriverService,
    private otherReservationService: OtherReservationService,
    private router: Router,
    private route: ActivatedRoute,
    private supplierService: SupplierService,
    private currencyService: CurrencyService,
  ) {}

  ngOnInit() {
    this.getVehicleCat();
    this.otherBookingFormErrorsInit();
    this.otherBookingFormInit();
    this.getCurrencyOptions();
    this.getDriverOptions();
    this.route.queryParams.subscribe((params) => {
      this.prevPage = params['prev'];
    });
    this.reservationId = this.route.snapshot.paramMap.get('id');

    if (this.reservationId) {
      this.loading = true;
      this.otherReservationService
        .getOtherBookingNormalById(this.reservationId)
        .then((res) => {
          this.bookingData = res;
          this.otherBookingForm.patchValue(this.bookingData);
          this.otherBookingForm
            .get('allocationDetails.driverAllocationCheck')
            .patchValue(
              this.bookingData.allocationDetails.driverAllocationCheck,
            );
          this.otherBookingForm
            .get('allocationDetails.driverCategory')
            .patchValue(this.bookingData.allocationDetails.driverCategory);
          this.otherBookingForm
            .get('allocationDetails.vehicleCategory')
            .patchValue(this.bookingData.allocationDetails.vehicleCategory);
          this.otherBookingForm
            .get('allocationDetails.allocatedVehicle')
            .patchValue(this.bookingData.allocationDetails.allocatedVehicle);
          this.otherBookingForm
            .get('allocationDetails.startFuel')
            .patchValue(this.bookingData.allocationDetails.startFuel);
          this.otherBookingForm
            .get('allocationDetails.startMileage')
            .patchValue(this.bookingData.allocationDetails.startMileage);
          this.otherBookingForm
            .get('allocationDetails.allocatedDriver')
            .patchValue(this.bookingData.allocationDetails.allocatedDriver);
          this.otherBookingForm
            .get('allocationDetails.allocatedDriverVehicle')
            .patchValue(
              this.bookingData.allocationDetails.allocatedDriverVehicle,
            );
          this.otherBookingForm
            .get('allocationDetails.outsourcedRate')
            .patchValue(this.bookingData.allocationDetails.outsourcedRate);
          this.getDriverOptions(
            this.bookingData.allocationDetails.driverCategory,
          );
          this.setBreadcrumbs();
          this.loading = false;
        });
    } else {
      this.setBreadcrumbs();
    }
  }

  otherBookingFormInit() {
    this.otherBookingForm = this.fb.group({
      reservationDetails: this.fb.group({
        reason: [null, [Validators.required]],
        arrivalDate: [null, [Validators.required]],
        arrivalTime: [null, [Validators.required]],
        arrivalDateAndTime: [null, []],
        departureDate: [null, [Validators.required]],
        departureTime: [null, [Validators.required]],
        departureDateAndTime: [null, []],
        noOfDays: [{ value: null, disabled: true }],
      }),
      allocationDetails: this.fb.group({
        vehicleCategory: [null],
        allocatedVehicle: [
          { value: null, disabled: true },
          [Validators.required],
        ],
        driverCategory: [null],
        startFuel: [null],
        startMileage: [null],
        driverAllocationCheck: [true, [Validators.required]],
        allocatedDriver: [null],
        allocatedDriverVehicle: [null],
        outsourcedRate: [null],
        outsourcedRateCurrency: ['65961e65cad7ae7c000623ff', []],
        outsourcedRateCurrencyDetails: [null, []],
        nonStatusFilter: null,
      }),
    });
    const arrivalDateControl = this.otherBookingForm.get(
      'reservationDetails.arrivalDate',
    );
    const departureDateControl = this.otherBookingForm.get(
      'reservationDetails.departureDate',
    );

    arrivalDateControl.valueChanges.subscribe(() => this.calculateNoOfDays());
    departureDateControl.valueChanges.subscribe(() => this.calculateNoOfDays());

    this.fleetOptionChangeOnDateChange();

    this.otherBookingForm.valueChanges.subscribe((values: any) => {
      if (values.allocationDetails.outsourcedRate) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.allocationDetails.outsourcedRateCurrency,
        );
        this.otherBookingForm
          .get('allocationDetails')
          .get('outsourcedRateCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }
    });

    // this.otherBookingForm
    //   .get('allocationDetails.vehicleCategory')
    //   .valueChanges.subscribe((value: any) => {
    //     // If vehicleCategory is null, disable the allocatedVehicle control
    //     if (value === null) {
    //       this.otherBookingForm
    //         .get('allocationDetails.allocatedVehicle')
    //         .disable();
    //     } else {
    //       this.otherBookingForm
    //         .get('allocationDetails.allocatedVehicle')
    //         .enable();
    //     }
    //   });

    this.otherBookingForm
      .get('allocationDetails.driverAllocationCheck')
      .valueChanges.subscribe((value: any) => {
        this.otherBookingForm
          .get('allocationDetails')
          .controls['allocatedVehicle'].enable();
        this.otherBookingForm
          .get('allocationDetails')
          .controls['vehicleCategory'].enable();
        this.otherBookingForm
          .get('allocationDetails')
          .controls['startMileage'].enable();
        this.otherBookingForm
          .get('allocationDetails')
          .controls['startFuel'].enable();
        this.driver.name = '-';
        this.driver.mobileNo = '-';
        this.driver.supplier = '-';

        if (value) {
          // Reset values to null when driverAllocationCheck is true
          this.otherBookingForm
            .get('allocationDetails.driverCategory')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.allocatedDriver')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.allocatedDriverVehicle')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.outsourcedRate')
            .setValue(null);
        }
      });

    this.otherBookingForm
      .get('allocationDetails.driverCategory')
      .valueChanges.subscribe((value: any) => {
        if (value === 'SR_DRIVER') {
          // Reset values to null when driverAllocationCheck is true
          this.otherBookingForm
            .get('allocationDetails.allocatedDriverVehicle')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.outsourcedRate')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.allocatedDriver')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails')
            .controls['allocatedVehicle'].enable();
        } else {
          this.otherBookingForm
            .get('allocationDetails')
            .controls['allocatedVehicle'].disable();
          this.otherBookingForm
            .get('allocationDetails.allocatedDriver')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.allocatedVehicle')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.vehicleCategory')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.startMileage')
            .setValue(null);
          this.otherBookingForm
            .get('allocationDetails.startFuel')
            .setValue(null);
        }
      });

    this.otherBookingForm
      .get('allocationDetails.allocatedDriver')
      .valueChanges.subscribe((value: any) => {
        if (
          this.otherBookingForm.get('allocationDetails.driverCategory')
            .value === 'OUTSOURCE_DRIVER' ||
          this.bookingData?.departureDetails?.driverCategory ===
            'OUTSOURCE_DRIVER'
        ) {
          this.otherBookingForm
            .get('allocationDetails.allocatedDriverVehicle')
            .setValue(null);
        }
      });

    this.otherBookingForm
      .get('reservationDetails')
      .valueChanges.subscribe((values: any) => {
        if (values.departureDate && values.departureTime) {
          let departureDateAndTime = new Date(values.departureDate);
          const departureTime = new Date(values.departureTime);
          departureDateAndTime = new Date(
            departureDateAndTime.setHours(departureTime.getHours()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setMinutes(departureTime.getMinutes()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setSeconds(departureTime.getSeconds()),
          );

          this.otherBookingForm
            .get('reservationDetails')
            .get('departureDateAndTime')
            .setValue(departureDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.otherBookingForm
            .get('reservationDetails')
            .get('departureDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
          this.getDriverOptions();
        }

        if (values.arrivalDate && values.arrivalTime) {
          let arrivalDateAndTime = new Date(values.arrivalDate);
          const arrivalTime = new Date(values.arrivalTime);
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setHours(arrivalTime.getHours()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setMinutes(arrivalTime.getMinutes()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setSeconds(arrivalTime.getSeconds()),
          );

          this.otherBookingForm
            .get('reservationDetails')
            .get('arrivalDateAndTime')
            .setValue(arrivalDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.otherBookingForm
            .get('reservationDetails')
            .get('arrivalDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });
  }

  fleetOptionChangeOnDateChange() {
    this.otherBookingForm
      .get('reservationDetails')
      .get('arrivalDate')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.otherBookingForm
      .get('reservationDetails')
      .get('arrivalTime')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.otherBookingForm
      .get('reservationDetails')
      .get('departureDate')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.otherBookingForm
      .get('reservationDetails')
      .get('departureTime')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
    this.otherBookingForm
      .get('allocationDetails')
      .get('vehicleCategory')
      .valueChanges.subscribe(() => {
        this.checkFleetOptionChange();
      });
  }
  checkFleetOptionChange() {
    this.otherBookingForm.get('allocationDetails.allocatedVehicle').disable();
    if (
      this.otherBookingForm.get('reservationDetails').get('arrivalDate')
        .value &&
      this.otherBookingForm.get('reservationDetails').get('arrivalTime')
        .value &&
      this.otherBookingForm.get('reservationDetails').get('departureDate')
        .value &&
      this.otherBookingForm.get('reservationDetails').get('departureTime')
        .value &&
      this.otherBookingForm.get('allocationDetails').get('vehicleCategory')
        .value
    ) {
      const vehicleCat = this.otherBookingForm
        .get('allocationDetails')
        .get('vehicleCategory')
        .getRawValue();
      this.getVehicles(vehicleCat);
      this.otherBookingForm.get('allocationDetails.allocatedVehicle').enable();
    }
  }

  calculateNoOfDays() {
    const arrivalDate = this.otherBookingForm.get(
      'reservationDetails.arrivalDate',
    ).value;
    const departureDate = this.otherBookingForm.get(
      'reservationDetails.departureDate',
    ).value;

    if (arrivalDate && departureDate) {
      const millisecondsPerDay = 1000 * 60 * 60 * 24;
      const arrivalTime = new Date(arrivalDate).getTime();
      const departureTime = new Date(departureDate).getTime();

      const differenceInTime = departureTime - arrivalTime;
      const noOfDays = Math.ceil(differenceInTime / millisecondsPerDay);

      this.otherBookingForm
        .get('reservationDetails.noOfDays')
        .setValue(noOfDays);
    }
  }

  otherBookingFormErrorsInit() {
    this.formErrors = {
      reservationDetails: {
        reason: {},
        arrivalDate: {},
        arrivalTime: {},
        departureDate: {},
        departureTime: {},
      },
      allocationDetails: {
        vehicleCategory: {},
        allocatedVehicle: {},
        startFuel: {},
        startMileage: {},
        driverAllocationCheck: {},
        allocatedDriver: {},
        allocatedDriverVehicle: {},
      },
    };
  }

  getVehicleCat(): void {
    this.fleetService.getAllVehicleCat().then((res) => {
      this.vehicleCat = res;
    });
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
    });
  }

  setBreadcrumbs(): void {
    if (this.reservationId) {
      this.breadcrumbs = [
        {
          title: 'Other Reservations',
          icon: 'car',
          route: '/admin/booking-other',
        },
        {
          title: 'Edit Other Booking',
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          title: 'Other Reservations',
          icon: 'car',
          route: '/admin/booking-other',
        },
        {
          title: 'Add New Other Booking',
        },
      ];
    }
  }

  getSupplierVehicles(event: any): void {
    if (
      this.otherBookingForm.get('allocationDetails').get('driverCategory')
        .value === 'OUTSOURCE_DRIVER' &&
      this.otherBookingForm.get('allocationDetails.allocatedDriver').value !==
        null
    ) {
      this.supplierVehiclesFetching = true;
      try {
        this.driverService
          .getSupplierVehiclesByDriver(event)
          .subscribe((res: any) => {
            this.supplierVehiclesFetching = false;
            this.supplierVehicleOptions = res?.supplierVehicles;
            this.filteredSupplierVehicleOptions = this.supplierVehicleOptions;
            this.supplierId = res?.supplierId;
          });
      } catch (e) {
        this.supplierVehiclesFetching = false;
      }
    } else {
      this.supplierVehiclesFetching = false;
    }
  }

  getVehicles(event: any): void {
    this.otherBookingForm
      .get('allocationDetails')
      .get('allocatedVehicle')
      .setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
    this.fleetsFetching = true;
    this.fleetService
      .getFleetsAsOptions({
        category: event,
        addEditBooking: true,
        ...this.datesAndIdSetForFleetOption(),
      })
      .then((res: any) => {
        this.fleetsFetching = false;
        this.availableVehicles = res;
        this.filteredAvailableVehicles = this.availableVehicles;
      });
  }
  datesAndIdSetForFleetOption() {
    const tourStartDate = this.otherBookingForm
      .get('reservationDetails')
      .get('arrivalDateAndTime')
      .getRawValue();
    const tourEndDate = this.otherBookingForm
      .get('reservationDetails')
      .get('departureDateAndTime')
      .getRawValue();
    if (tourStartDate && tourEndDate) {
      return {
        tourStartDate,
        tourEndDate,
        bookingId: this.reservationId ? this.reservationId : null,
      };
    }
    return {};
  }
  getVehicleAvailabilityIcon(status: string) {
    return this.availabilityStatusPairs.find((st) => st.value === status);
  }
  getDriverAvailabilityIcon(status: string) {
    return this.driverAvailabilityStatus.find((st) => st.value === status);
  }

  getDriverOptions(event?: any): void {
    const payload = {
      driverSegment: event,
      startDate: AppUtils.mergeDateAndTime(
        this.otherBookingForm.get('reservationDetails').get('arrivalDate')
          .value,
        this.otherBookingForm.get('reservationDetails').get('arrivalTime')
          .value,
      ),
      endDate: AppUtils.mergeDateAndTime(
        this.otherBookingForm.get('reservationDetails').get('departureDate')
          .value,
        this.otherBookingForm.get('reservationDetails').get('departureTime')
          .value,
      ),
      addEditBooking: true,
      ...this.datesAndIdSetForFleetOption(),
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.availableDriver = res;
      this.filteredAvailableDriver = this.availableDriver;
    });
    if (
      this.otherBookingForm
        .get('allocationDetails')
        .get('driverAllocationCheck').value &&
      event === 'OUTSOURCE_DRIVER'
    ) {
      this.otherBookingForm
        .get('allocationDetails')
        .controls.allocatedVehicle.setValue(null, {
          onlySelf: true,
          emitEvent: false,
        });
      this.otherBookingForm
        .get('allocationDetails')
        .controls['allocatedVehicle'].disable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['vehicleCategory'].disable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['startMileage'].disable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['startFuel'].disable();
    } else {
      this.otherBookingForm
        .get('allocationDetails')
        .controls['allocatedVehicle'].enable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['vehicleCategory'].enable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['startMileage'].enable();
      this.otherBookingForm
        .get('allocationDetails')
        .controls['startFuel'].enable();
    }
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.otherBookingForm
          .get('allocationDetails')
          .get('allocatedDriver')
          .reset();
        this.otherBookingForm
          .get('allocationDetails')
          .get('driverCategory')
          .setValue(event.value, {
            onlySelf: true,
            emitEvent: false,
          });
        this.getDriverOptions();
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  showAddVehiclePopup(): void {
    this.visibleAddVehiclePopup = true;
  }

  onGetAddVehicleChange(event: any): void {
    console.log(event);
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehiclePopup = false;
        break;
      case 'submit':
        // this.message.create('success', ' New Vehicle has been added!');
        this.getSupplierVehicles(
          this.otherBookingForm.get('allocationDetails.allocatedDriver').value,
        );
        this.visibleAddVehiclePopup = false;
        break;
    }
  }

  bookingCancel() {
    if (this.prevPage) {
      this.router.navigate([`/admin/booking-other/${this.reservationId}`]);
    } else {
      this.router.navigate(['/admin/booking-other']);
    }
  }

  submit() {
    const formData = this.otherBookingForm.getRawValue();
    if (this.reservationId) {
      this.otherReservationService
        .updateBooking({
          _id: this.reservationId,
          ...this.otherBookingForm.value,
        })
        .then((resp) => {
          if (this.prevPage) {
            this.subbmit = true;
            this.router.navigate([
              `/admin/booking-other/${this.reservationId}`,
            ]);
          } else {
            this.subbmit = true;
            this.router.navigate(['/admin/booking-other']);
          }
        });
    } else {
      if (this.otherBookingForm.valid) {
        this.otherReservationService.createOtherReservation(formData).subscribe(
          (res: any) => {
            if (
              this.otherBookingForm.get('allocationDetails.allocatedDriver')
                .value
            ) {
              const payload = {
                startDate: this.otherBookingForm.get(
                  'reservationDetails.arrivalDateAndTime',
                ).value,
                endDate: this.otherBookingForm.get(
                  'reservationDetails.departureDateAndTime',
                ).value,
              };
              this.driverService
                .getDriverOptionsWithUpcoming(payload)
                .subscribe((res: any) => {
                  const driversList = res;
                  let tours = [];

                  const driverSelected = driversList.find(
                    (driver: { _id: any }) =>
                      driver._id ===
                      this.otherBookingForm.get(
                        'allocationDetails.allocatedDriver',
                      ).value,
                  );

                  if (driverSelected.tourDetails.upcomingTours) {
                    tours = driverSelected.tourDetails.upcomingTours;
                  }

                  tours.push({
                    startTime: res.reservationDetails.arrivalDateAndTime,
                    endTime: res.reservationDetails.departureDateAndTime,
                    duration: res.reservationDetails.noOfDays,
                    tourType: 'Other',
                    tourId: res._id,
                  });

                  this.driverService
                    .updateDriver({
                      _id: this.otherBookingForm.get(
                        'allocationDetails.allocatedDriver',
                      ).value,
                      tourDetails: {
                        upcomingTours: tours,
                      },
                    })
                    .subscribe((res) => {
                      console.log('works', res);
                    });
                });
            }
            this.message.create(
              'success',
              'New Other Reservation has been added!',
            );
            this.subbmit = true;
            this.router.navigate(['/admin/booking-other']);
          },
          (e: any) => {
            const errorMessage = e.error?.message || 'An error occurred';
            this.message.create('error', errorMessage);
          },
        );
      }
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.subbmit) {
      return true;
    } else if (this.otherBookingForm.dirty || this.otherBookingForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, new Date()) < 0;

  onSearchAllocatedVehicle(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.filteredAvailableVehicles = this.availableVehicles.filter(
        (vehicle) =>
          vehicle.vehicleName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.filteredAvailableVehicles = this.availableVehicles;
    }
  }

  onSearchSupplierVehicle(searchValue: string): void {
    if (searchValue) {
      // Filter the supplier vehicles based on the search value
      this.filteredSupplierVehicleOptions = this.supplierVehicleOptions.filter(
        (option: {
          _id: string;
          registerNumber: string;
          vehicleModel: string;
        }) =>
          option.registerNumber
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          option.vehicleModel.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all supplier vehicles
      this.filteredSupplierVehicleOptions = this.supplierVehicleOptions;
    }
  }

  onSearchDriver(searchValue: string): void {
    if (searchValue) {
      // Filter the available drivers based on the search value
      this.filteredAvailableDriver = this.availableDriver.filter(
        (driver: { _id: string; fullName: string }) =>
          driver.fullName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available drivers
      this.filteredAvailableDriver = this.availableDriver;
    }
  }

  getFleetVehicle(event: any, nonStatusFilter: boolean = true) {
    // Initialize vehicle with default values
    this.vehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
    };

    if (event) {
      this.fleetService.getOneFleetById(event).then((res) => {
        // Update vehicle image if available
        if (res.generalInformation?.vehicleImg?.length > 0) {
          this.vehicle.image = res.generalInformation.vehicleImg[0];
        }
        // Update vehicle seats and registration number if available
        if (res.vehicleDetails) {
          this.vehicle.seats =
            res.vehicleDetails.seatsNumber ?? this.vehicle.seats;
          this.vehicle.registrationNo =
            res.vehicleDetails.registrationNumber ??
            this.vehicle.registrationNo;
        }
      });
    }
  }

  getSupplierVehicle(event: any) {
    this.vehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
    };
    const foundVehicle = this.supplierVehicleOptions.find(
      (vehicle) => vehicle._id === event,
    );
    if (foundVehicle) {
      if (foundVehicle.vehicleImages[0]?.attach?.url) {
        this.vehicle.image = foundVehicle.vehicleImages[0]?.attach?.url;
      }
      this.vehicle.registrationNo = foundVehicle.registerNumber;
    } else {
      // console.log('Vehicle not found');
    }
  }

  getDriver(event: any) {
    this.driver = {
      name: '-',
      mobileNo: '-',
      supplier: '-',
    };
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.supplierService.getSuppliersById(res.supplier).then((supplier) => {
          this.driver.mobileNo = res.mobileNumber;
          this.driver.name = res.fullName;
          this.driver.supplier = supplier.supplierDetails?.name;
        });
      } else {
        this.driver.mobileNo = res.mobileNumber;
        this.driver.name = res.fullName;
      }
    });
  }
  disableSelectedVehicle(vehicleId: string) {
    return this.bookingData?.allocationDetails?.allocatedVehicle &&
      this.otherBookingForm?.get('allocationDetails')?.get('allocatedVehicle')
        ?.value
      ? this.bookingData.allocationDetails.allocatedVehicle.toString() ===
          vehicleId.toString()
      : false;
  }
  disableSelectedOutSourceVehicle(vehicleId: string) {
    return this.bookingData?.allocationDetails?.allocatedDriverVehicle &&
      this.otherBookingForm
        ?.get('allocationDetails')
        ?.get('allocatedDriverVehicle')?.value
      ? this.bookingData.allocationDetails.allocatedDriverVehicle.toString() ===
          vehicleId.toString()
      : false;
  }

  refreshVehicles() {
    // Check if vehicle category is selected
    const vehicleCat = this.otherBookingForm
      .get('allocationDetails')
      .get('vehicleCategory')
      .getRawValue();
    
    if (vehicleCat) {
      // Disable the allocated vehicle control during refresh
      this.otherBookingForm
        .get('allocationDetails.allocatedVehicle')
        .disable();
      
      // Reset the allocated vehicle to null
      this.otherBookingForm
        .get('allocationDetails.allocatedVehicle')
        .setValue(null, {
          onlySelf: true,
          emitEvent: false,
        });
      
      // Set fetching flag to true
      this.fleetsFetching = true;
      
      // Call getFleetsAsOptions with the same parameters as in getVehicles method
      this.fleetService
        .getFleetsAsOptions({
          category: vehicleCat,
          addEditBooking: true,
          ...this.datesAndIdSetForFleetOption(),
        })
        .then((res: any) => {
          // Update available vehicles
          this.fleetsFetching = false;
          this.availableVehicles = res;
          this.filteredAvailableVehicles = this.availableVehicles;
          
          // Re-enable the allocated vehicle control
          this.otherBookingForm
            .get('allocationDetails.allocatedVehicle')
            .enable();
        })
        .catch((error) => {
          // Handle any errors
          this.fleetsFetching = false;
          // Optionally show an error message
          this.message.create('error', 'Failed to refresh vehicles');
        });
    } else {
      // Show a message if no vehicle category is selected
      this.message.create('warning', 'Please select a vehicle category first');
    }
  }

  refreshDrivers() {
    // Get the current driver category
    const driverCategory = this.otherBookingForm
      .get('allocationDetails.driverCategory')
      .value;
  
    // Reset the allocated driver
    this.otherBookingForm
      .get('allocationDetails.allocatedDriver')
      .setValue(null);
  
    // Set fetching flag
    this.driversFetching = true;
  
    // Call getDriverOptions method
    this.getDriverOptions(driverCategory);
  }

}
